// extracted by mini-css-extract-plugin
module.exports = {"tablet":"(max-width: 1024px)","container":"container-20qEe","identity":"identity-36BIG","field_middleName":"field_middleName-2XHgC","documents":"documents-1w1pN"};